<template>
  <div class="mobile-components">
    <en-input
      :full-data="fullData"
      class="components"
      v-if="parseInt(fullData.fieldType,10) === 1"
      v-model="fullData.value"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-input>
    <textarea
      rows="5"
      class="components textarea"
      v-if="parseInt(fullData.fieldType,10) === 2"
      v-model="fullData.value"
      placeholder="请输入"
      ref="textareaContent"
      @change="changeValue"
      :readonly="disabled || fullData.disabled"
    >
    </textarea>
    <en-input
      class="components"
      :full-data="fullData"
      v-if="parseInt(fullData.fieldType,10) === 3"
      v-model="fullData.value"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-input>
    <en-input
      class="components"
      :full-data="fullData"
      v-if="parseInt(fullData.fieldType,10) === 4"
      v-model="fullData.value"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-input>
    <en-select
      class="components"
      :commondata="commondata"
      :full-data="fullData"
      v-if="parseInt(fullData.fieldType,10) === 5"
      v-model="fullData.value"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-select>
    <en-date
      class="components"
      :full-data="fullData"
      v-if="parseInt(fullData.fieldType,10) === 7"
      v-model="fullData.value"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-date>
    <en-file
      class="components"
      :full-data="fullData"
      v-model="fullData.value"
      v-if="parseInt(fullData.fieldType,10) === 9"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-file>
    <en-city
      class="components"
      :full-data="fullData"
      v-if="parseInt(fullData.fieldType,10) === 29"
      v-model="fullData.value"
      @change="changeValue"
      :disabled="disabled || fullData.disabled"
    >
    </en-city>
    <en-flow :full-data="fullData"></en-flow>
    <i
      class="el-icon el-icon-arrow-right right-icon"
      v-if="parseInt(fullData.fieldType,10) === 5 ||
      parseInt(fullData.fieldType,10) === 7 ||
      parseInt(fullData.fieldType,10) === 44"
    >
    </i>
  </div>
</template>

<script>
import enInput from "./../en-input";
import enCity from "./../en-city";
import enDate from "./../en-date";
import enSelect from "./../en-select";
import enFile from "./../en-file";
import enFlow from "./../en-flow";

export default {
  name: "index",
  components: {
    enInput,
    enCity,
    enDate,
    enSelect,
    enFile,
    enFlow
  },
  props: {
    value: {
      type: [Object, Array, String, Number]
    },
    commondata: Object,
    fullData: {
      type: [Object, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: null
    };
  },
  computed: {
    uploadInfo() {
      return localStorage.getItem("uploadInfo") ? JSON.parse(localStorage.getItem("uploadInfo")) : null;
    }
  },
  mounted() {
    if (parseInt(this.fullData.fieldType, 10) === 2 || parseInt(this.fullData.fieldType, 10) === 3 || parseInt(this.fullData.fieldType, 10) === 4) {
      this.inputValue = this.fullData.value;
    }
    if (this.fullData.mdValue) {
      this.inputValue = this.fullData.mdValue;
    }
  },
  methods: {
    changeValue(itemData) {
      this.$emit("change", itemData);
    }
  }
}
;
</script>

<style lang="scss">
  .mobile-components {
    width: 100%;

    .components {
      &.textarea {
        outline: none;
        border: none;
        font-size: 14px;
        line-height: 20px;
        padding: 17px 0;
        text-align: right;
        color: #848484;
        width: 100%;

        &::placeholder {
          color: #C7C7CC;
        }

        &:read-only {
          color: #333333;
          opacity: 1;
          background-color: #f9f9f9;
        }
      }

      .show-content {
        color: #848484;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;

        &.is-disabled {
          color: #333333;
          background-color: #f9f9f9;
        }

        &.no-data {
          color: #C7C7CC;
        }


      }

      input {
        height: 40px;
        width: 100%;
        line-height: 40px;
        border: none;
        outline: none;
        font-size: 14px;
        text-align: right;
      }
    }

    .right-icon {
      position: absolute;
      right: 10px;
      top: 16px;
      color: #848484;
    }
  }
</style>
